import {
  Navigate,
  useLocation,
  Link
} from 'react-router-dom'
import { URLs, pathForPendingFlow, safeNext, useAuthStatus, withSafeNext } from '../auth'

function retryLoginURL (search) {
  const loginURL = withSafeNext(URLs.LOGIN_URL, search)
  const separator = loginURL.includes('?') ? '&' : '?'
  return `${loginURL}${separator}sso_error=1`
}

export default function ProviderCallback () {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const error = params.get('error')
  const [auth, status] = useAuthStatus()

  let url = retryLoginURL(location.search)
  if (status.isAuthenticated) {
    url = safeNext(location.search) || URLs.LOGIN_REDIRECT_URL
  } else {
    const pendingPath = pathForPendingFlow(auth)
    if (pendingPath) url = withSafeNext(pendingPath, location.search)
  }
  if (!error) {
    return <Navigate to={url} replace />
  }
  return (
    <>
      <h1 className='tti-page-title'>Third-Party Login Failure</h1>
      <p>Something went wrong.</p>
      <Link to={url}>Continue</Link>
    </>
  )
}
